// extracted by mini-css-extract-plugin
module.exports = {"header":"header--1Cm56","block":"block--qb4YZ","block-title":"block-title--1ls0q","btn-line":"btn-line--3z0Lu"};